/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { call, put, takeLatest } from 'redux-saga/effects'
import { browserHistory } from 'react-router'
import moment from 'moment'

import * as action from 'actions'
import { setNotificationMessage, setNotificationType } from 'actions/billingRedirect'
import { BILLING_REDIRECT_UPDATE_PAYMENT_STATUS } from 'actions/billingRedirect/constant'
import { updatePaymentStatus } from 'api/billingRedirect'
import { getProfile } from 'api/profile'
import { isSubscriptionExpired } from 'actions/subscriptionExpired'

export function * updatePaymentStatusFlow (request) {
  action.showProgressBar()
  const queryParams = {
    order_id: request.payload.orderId,
    status_code: request.payload.statusCode,
    transaction_status: request.payload.transactionStatus
  }
  const response = yield call(updatePaymentStatus, queryParams)
  const {message, type, url} = response.data
  yield put(setNotificationMessage(message))
  yield put(setNotificationType(type))
  const resProfile = yield call(getProfile)
  if (moment(resProfile.data.business.expired_at) > moment()) yield put(isSubscriptionExpired(false))
  action.hideProgressBar()
  browserHistory.push(`${url}`)
}

export default function * billingRedirectSaga () {
  yield takeLatest(BILLING_REDIRECT_UPDATE_PAYMENT_STATUS, updatePaymentStatusFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/billingRedirect/billingRedirect.js